export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_REQUEST_SUCCESS = 'AUTH_REQUEST_SUCCESS';
export const AUTH_REQUEST_ERROR = 'AUTH_REQUEST_ERROR';

export const AUTH_TOKEN = 'AUTH_TOKEN';
export const AUTH_TOKEN_SUCCESS = 'AUTH_TOKEN_SUCCESS';
export const AUTH_TOKEN_ERROR = 'AUTH_TOKEN_ERROR';

export const AUTH_FIRST = 'AUTH_FIRST';
export const AUTH_FIRST_SUCCESS = 'AUTH_FIRST_SUCCESS';
export const AUTH_FIRST_ERROR = 'AUTH_FIRST_ERROR';
export const CANCEL_FIRST = 'CANCEL_FIRST';

export const FINISH_FIRST = 'FINISH_FIRST';
export const FINISH_FIRST_SUCCESS = 'FINISH_FIRST_SUCCESS';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SUM_POINTS = 'SUM_POINTS';
export const UPDATE_USER = 'UPDATE_USER';
